import type { ReactElement } from 'react';

import { useEffect } from 'react';
import CloseIcon from '../../../../../public/assets/images/icons/CloseIcon';
import IconButton from '../../IconButton';
import LiveRegion from '../../LiveRegion';
import styles from './ErrorPopup.module.scss';
import { useTranslations } from 'next-intl';
import { useErrorHandlingStore } from '../../../../stores/errorHandlingStore';

export default function ErrorPopup(): ReactElement {
  const t = useTranslations('Common');
  //store
  const errors = useErrorHandlingStore((state) => state.errors);
  const setErrors = useErrorHandlingStore((state) => state.setErrors);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (errors) {
      timer = setTimeout(() => {
        setErrors(null);
      }, 10000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [errors]);

  const handleRemoveError = (message: string) => {
    if (errors) {
      const updatedErrors = errors.filter((err) => err.message !== message);
      if (updatedErrors.length === 0) {
        setErrors(null);
      } else {
        setErrors(updatedErrors);
      }
    }
  };

  const processErrorMessage = (errorMessage: string) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const translatedError = t(errorMessage);
    if (translatedError.startsWith('Common.')) {
      return errorMessage;
    } else {
      return translatedError;
    }
  };

  return (
    <>
      {errors &&
        errors.length > 0 &&
        errors.map((err, index) => {
          return (
            <div key={`${index}`} className={styles.errorContainer}>
              <IconButton
                id={'errorCloseButton'}
                label={t('close')}
                className={styles.closeButton}
                onClick={() => handleRemoveError(err.message)}
              >
                <CloseIcon color={'#f44336'} width={'10'} height={'10'} />
              </IconButton>
              {/* Assertive: an API failure the user must hear immediately.
                  Scoped to the message so the close button is not announced
                  as part of the alert. */}
              <LiveRegion
                politeness="assertive"
                className={styles.errorContent}
              >
                {processErrorMessage(err.message)}
              </LiveRegion>
            </div>
          );
        })}
    </>
  );
}
